import { getValue, isArray, isEmpty, isObject } from "../shared/miscUtils";

/**
 * Update the error and helperText fields.
 */
export const setFormValues = (obj = {}, key, error, helperText) => {
    obj["form"][key]["error"] = error;
    obj["form"][key]["helperText"] = helperText;
};

/**
 * Return the error and helperText fields.
 */
export const getRowFormValues = (row, key) => {
    return row["form"][key];
};

/**
 * Return whether the object is saved.
 */
export const formIsSaved = (obj = {}) => {
    return obj["form"]["saved"];
};

/**
 * Boolean whether all value(s) from arr1 aren't present in arr2.
 */
export const isValidValues = (arr = [], invalid = ["", undefined, null]) => {
    for (const value of arr) {
        if (invalid.includes(value)) return false;
    }

    return true;
};

/**
 * Return whether the user has inputted something to the field.
 */
export const formHasValue = (obj = {}, key) => {
    const value = getValue(obj, key);

    if (value === undefined || value === "") return false;
    if (isObject(value) || isArray(value)) return !isEmpty(value);

    return true;
};

/**
 * Return whether any input elements in some row have errors.
 * Allows to exclude certain keys.
 */
export const formHasErrors = (obj = {}, exclude = []) => {
    const form = obj.form;

    for (const entry of Object.entries(form)) {
        const key = entry[0];
        const value = entry[1];

        if (exclude.includes(key)) continue;
        if (value.error) return true;
    }

    return false;
};

/**
 * Return an array of all the form values of the object.
 */
export const getFormValuesAsArray = (obj = {}, key = "") => {
    const values = Object.values(obj);
    const res = [];

    for (const row of values) {
        res.push(row["form"][key]);
    }

    return res;
};

/**
 * In use for fields that don't require any special validation rules.
 */
export const noValidation = (prevObj, row, value) => {
    return prevObj;
};

/**
 * Loop through the row fields, and execute each validation function.
 * Return the config object.
 */
export const validateRow = (prevObj, validation, row, exclude = [], options = {}) => {
    for (const type of Object.keys(validation)) {
        if (exclude.includes(type)) continue;

        if (validation[type].check) {
            validation[type].check(prevObj, row, getValue(row, type), options);
        }
    }
};
